var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.419173 7.21062e-05C0.312096 7.21062e-05 0.205098 0.0410217 0.123051 0.123061C-0.041017 0.287142 -0.041017 0.551707 0.123051 0.715789L1.21911 1.81133L0.123051 2.90739C-0.041017 3.07147 -0.041017 3.33552 0.123051 3.4996C0.287146 3.66368 0.551703 3.66368 0.715797 3.4996L1.81133 2.40406L2.90739 3.4996C3.07146 3.66368 3.33552 3.66368 3.49958 3.4996C3.66368 3.33552 3.66368 3.07147 3.49958 2.90739L2.40405 1.81133L3.49958 0.715789C3.66368 0.551707 3.66368 0.287142 3.49958 0.123061C3.33552 -0.0410203 3.07146 -0.0410203 2.90739 0.123061L1.81133 1.21912L0.715797 0.123061C0.63375 0.041019 0.526223 7.21062e-05 0.419173 7.21062e-05V7.21062e-05Z"}));
}

CloseInline.defaultProps = {"width":"100%","height":"100%","className":"close-btn","viewBox":"0 0 4 4","fill":"none"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
